export default {
  menu: (state) => state.navbar.menu,
  menuSearch: (state) => state.navbar.menuSearch,
  systems: (state) => state.navbar.systems,
  user: (state) => state.navbar.user,
  favoriteIcon: (state) => state.navbar.icon,
  totalNotification: (state) => state.navbar.totalNotification,
  pagesNotification: (state) => state.navbar.pagesNotification,
  numberNotification: (state) => state.navbar.numberNotification,
  notification: (state) => state.navbar.notifications,
  menuCollapse: (state) => state.navbar.menuCollapse,
  gridNotification: (state) => state.navbar.gridNotification,
  gridRefresh: (state) => state.navbar.gridRefresh,
  about: (state) => state.navbar.about,
  favoritosSelecionados: (state) => state.navbar.favoritosSelecionados,
};
